export default {
	actionIcon: 'StarIcon',
	highlightColor: 'warning',
	data: [
		// MATCH
		{index: 1, label: '参赛记录', url: '/match/list', labelIcon: 'FlagIcon', highlightAction: true},
		{index: 2, label: '创建的团队', url: '/team/create-list', labelIcon: 'UserPlusIcon', highlightAction: false},
		{index: 3, label: '加入的团队', url: '/team/create-list', labelIcon: 'UserCheckIcon', highlightAction: false},
		{index: 4, label: '个人信息', url: '/user/profile', labelIcon: 'UserIcon', highlightAction: false}
	]
}
